import React, { useState } from 'react';
import { Toast } from '../../components/molecules/Toast/Toast';
import PortfolioApprovalsOrganism from '../../components/organisms/PortfolioApprovals';
import { Approval } from './hooks';
import ApprovalSummary from './approval-summary';

interface PlanTransferApprovalsProps {
    pendingApprovals?: Approval[];
    // eslint-disable-next-line no-unused-vars
    approve?: (id: string, submitter: string) => void;
    // eslint-disable-next-line no-unused-vars
    reject?: (id: string, submitter: string) => void;
    isLoading?: boolean;
    actionLoading?: { [id: string]: boolean };
    snackbar?: {
        open: boolean;
        message: string;
        type: 'success' | 'error' | null;
        // eslint-disable-next-line no-unused-vars
    };
}

const PlanTransferApprovals: React.FC<PlanTransferApprovalsProps> = React.memo(
    ({ pendingApprovals, approve, reject, isLoading, actionLoading, snackbar }) => {
        const [open, setOpen] = useState(true);
        console.log('Rendering PlanTransferApprovals', pendingApprovals);
        const summaryComponent = (item: Approval) => (
            <ApprovalSummary
                date={item.date}
                submitter={item.submitter}
                userId={item.userId}
                fromUser={item.fromUser || ''}
                fromUserEmail={item.fromUserEmail || ''}
                fromUserName={item.fromUserName || ''}
                toUser={item.toUser || ''}
                toUserEmail={item.toUserEmail || ''}
                toUserName={item.toUserName || ''}
                onApprove={() => approve?.(item.id, item.submitter)}
                onReject={() => reject?.(item.id, item.submitter)}
            />
        );

        return (
            <>
                <PortfolioApprovalsOrganism
                    pendingApprovals={pendingApprovals || []}
                    open={open}
                    onApprove={(id: string) => approve?.(id, '')}
                    onReject={(id: string) => reject?.(id, '')}
                    onToggle={() => setOpen((prev) => !prev)}
                    isLoading={isLoading}
                    actionLoading={actionLoading}
                    hasExpandableDetails={false}
                    summaryComponent={summaryComponent}
                />
                {snackbar?.open && (
                    <Toast
                        heading={snackbar.type === 'success' ? 'Approved' : 'Rejected'}
                        type={snackbar.type === 'success' ? 'confirm' : 'error'}
                        disappearTime={5}
                        isTimer={true}
                        messages={[snackbar.message]}
                    />
                )}
            </>
        );
    }
);

PlanTransferApprovals.displayName = 'PlanTransferApprovals';

export default PlanTransferApprovals;
